import script from "./StepButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepButton.vue?vue&type=script&setup=true&lang=ts"

import "./StepButton.vue?vue&type=style&index=0&id=09a10550&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09a10550"]])

export default __exports__